<header id="header">
  <div class="header-container app-container-basic" [class.login]="isLoggedIn">
    <img
      *ngIf="logoUrl"
      [src]="logoUrl"
      (click)="backHome()"
      class="header-logo"
      [class.logged-in]="isLoggedIn"
    />

    <lynx-locale-selector
      *ngIf="!isLoggedIn"
      [colorScheme]="colorScheme"
      [dropDownPlacement]="isMobile ? 'right' : 'left'"
    ></lynx-locale-selector>

    <div *ngIf="isLoggedIn" class="user-section">
      <div class="user-info">
        <img
          *ngIf="logoUrl"
          [src]="logoUrl"
          (click)="backHome()"
          class="mobile-logo"
        />
        <div class="info-block">
          <lynx-username></lynx-username>
          <lynx-auth-logout></lynx-auth-logout>
        </div>
      </div>
      <div class="user-actions" [ngClass]="{ 'is-mobile': isMobile }">
        <lynx-locale-selector
          [colorScheme]="colorScheme"
          [dropDownPlacement]="'left'"
        ></lynx-locale-selector>
        <lynx-userbalance>
          <lynx-game-search></lynx-game-search>
        </lynx-userbalance>
      </div>
    </div>
  </div>
  <ng-content></ng-content>
</header>
